export const spaceBetween = {
    display: 'flex',
    justifyContent: 'space-between'
};
export const addButton = {
    fontWeight: 500,
    fontSize: "11px",
    color: "#FFBC00"
};
